/** Build an Outlook (Office 365) web calendar compose link for an all-day event. */
export function buildOutlookCalendarUrl(opts: {
  title: string;
  eventDate: string;
  description?: string;
}): string {
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: opts.title,
    startdt: opts.eventDate,
    enddt: opts.eventDate,
    allday: 'true',
  });
  if (opts.description) {
    params.set('body', opts.description);
  }
  return `https://outlook.office.com/calendar/0/deeplink/compose?${params.toString()}`;
}
